import {observer} from 'mobx-react';
import {autoinject, bind, inject} from 'Mri.Web.Common';
import * as React from 'react';
import {action, observable, runInAction} from "mobx";
import {AppStore} from "./AppStore";

export interface IIdleCheckProps {}

@autoinject
@observer
export class IdleCheck extends React.Component<IIdleCheckProps> {
    @bind
    @action
    public componentDidMount() {
        this.resetIdleTimer();
        window.addEventListener('mousemove', this.resetIdleTimer);
        window.addEventListener('keydown', this.resetIdleTimer);
    }

    @bind
    @action
    public componentWillUnmount() {
        window.removeEventListener('mousemove', this.resetIdleTimer);
        window.removeEventListener('keydown', this.resetIdleTimer);
        window.clearTimeout(this.idleTimeout);
    }


    public render() {
        return (
            <div className="d-none">
                {this.appStore.isIdle ? "User is idle" : "User is active"}
            </div>
        );
    }

    @bind
    @action
    private resetIdleTimer() {
        if(this.idleTimeout) {
            window.clearTimeout(this.idleTimeout);
        }
        if (this.appStore.isIdle) {
            this.appStore.isIdle = false;
        }
        this.idleTimeout = window.setTimeout(() => {
            runInAction(() => {
                this.appStore.isIdle = true;
            })
        }, this.idleTime);

    }
    
    private idleTimeout?: number;
    private idleTime = 15 * 60 * 1000; // 15 minutes
    @inject
    private appStore!: AppStore;
}
